import apiMiddleware from '../../Utility/middleware';
import React, { useEffect, useState } from 'react';
import Loader from '../../GlobalComponents/Loader/Loader';
import { useParams } from 'react-router-dom';

const Pingpage = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [PingData, setPingData] = useState(null);  // Initialize as null instead of false

  useEffect(() => {
    setLoading(true);

    const handleCrudOperation = async () => {
      const body = {
        "queryType": "custom-query",
        "table": "tbl_devices",
        "data": {
          "query": `SELECT * FROM PING_LOG WHERE HOST_IP = '${id}' ORDER BY CREATION_DATE DESC`
        }
      };

      const response = await apiMiddleware('POST', body);

      if (response.success) {
        setLoading(false);
        setPingData(response.data); 
        
        
      } else {
        console.error('CRUD Operation Failed:', response.error);
      }
    };

    handleCrudOperation();
  }, [id]);

  if (loading) {
    return <Loader />;
  }

  // Check if PingData is available and not empty
  if (!PingData || PingData.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">Maintenance Result</h2>
        <div>No ping data found for this IP address.</div>
      </div>
    );
  }

  const resultString = PingData[0].PING_RESULT;
  const resultJson = JSON.parse(resultString);
 

  return (
    <>
      <div className="bg-SoftBlack md:mt-0 md:pt-3 p-5 mt-16 text-gray-300 h-screen">
        <h2 className="text-xl font-semibold mb-4">Device Satics</h2>
        <div className="space-y-4 bg-DarkBlue p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <span className="font-medium text-gray-630">IP Address:</span>
              <div className="mt-1">{resultJson.ip}</div>
            </div>
            <div>
              <span className="font-medium text-gray-300">Status:</span>
              <div className="mt-1">
                <span
                  className={`inline-flex items-center justify-center ${resultJson.status === "Healthy"
                      ? "text-green-600"
                      : resultJson.status === "Delayed"
                        ? "text-yellow-600"
                        : "text-red-600"
                    }`}
                >
                  {resultJson.status === "Healthy"
                    ? "Healthy"
                    : resultJson.status === "Delayed"
                      ? "Delayed"
                      : "Unresponsive"}
                </span>
              </div>
            </div>
            <div>
              <span className="font-medium text-gray-300">Response Time:</span>
              <div className="mt-1">
                <span
                  className={`inline-flex items-center justify-center ${resultJson.time === null
                      ? "text-red-600" // Null ping time: red (error)
                      : resultJson.time <= 100
                        ? "text-green-600" // Ping time <= 100: green
                        : resultJson.time > 100
                          ? "text-yellow-600" // Ping time > 100: yellow
                          : ""
                    }`}
                >
                  {resultJson.time === null
                    ? "Error" // Null ping time: show "Error"
                    : resultJson.time <= 100
                      ? `${resultJson.time} ms (Healthy)` // Ping time <= 100: green with "Healthy"
                      : `${resultJson.time} ms (Delayed)`}
                </span>
              </div>
            </div>
          </div>

          <div className="border-t pt-4 mt-4 bg-DarkBlue">
            <h3 className="font-medium text-gray-300 mb-3">Detailed Statistics:</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <span className="text-sm text-gray-300">Minimum</span>
                <div className="font-medium">{resultJson.details.min}</div>
              </div>
              <div>
                <span className="text-sm text-gray-300">Maximum</span>
                <div className="font-medium">{resultJson.details.max}</div>
              </div>
              <div>
                <span className="text-sm text-gray-300">Average</span>
                <div className="font-medium">{resultJson.details.avg}</div>
              </div>
              <div>
                <span className="text-sm text-gray-300">Packet Loss</span>
                <div className="font-medium">{resultJson.details.packetLoss}</div>
              </div>
            </div>
          </div>

          {/* <div className="text-sm text-gray-300 border-t pt-4">
            Last Updated: {new Date(resultJson.timestamp).toLocaleString()}
          </div> */}
          
          <div className="bg-DarkBlue rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-4">Ping History</h2>
            <div className="overflow-x-auto h-[20rem] pb-10">
              <table className="min-w-full table-auto">
                <thead>
                  <tr className="border-b">
                    <th className="text-left py-2 px-4 text-gray-600">S.No</th>
                    <th className="text-left py-2 px-4 text-gray-600">IP Address</th>
                    <th className="text-left py-2 px-4 text-gray-600">Status</th>
                    <th className="text-left py-2 px-4 text-gray-600">Response Time</th>
                    <th className="text-left py-2 px-4 text-gray-600">Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {PingData.map((item, index) => {
                    const result = JSON.parse(item.PING_RESULT); 

                    return (
                      <tr 
                        key={index}
                        className="border-b last:border-b-0"
                      >
                        <td className="py-3 px-4 text-gray-500">
                          {index + 1}
                        </td>
                        <td className="py-3 px-4">{item.HOST_IP}</td>
                        <td className="py-3 px-4">
                          <span className={`px-2 py-1 rounded-full text-xs text-white
                            ${result.status === 'Healthy' 
                              ? 'bg-green-500' 
                              : result.status === 'Delayed' 
                                ? 'bg-yellow-500' 
                                : 'bg-red-500'}`}
                          >
                            {result.status}
                          </span>
                        </td>
                        <td className="py-3 px-4">{result.time}{result.time ? 'ms' : 'N/A'}</td>
                        <td className="py-3 px-4 text-sm text-gray-500">
                          {new Date(result.timestamp).toLocaleString()}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pingpage;